module.exports = __webpack_public_path__ + "static/media/book3cover_preview.77293a39.png";